/**
 * Vuex "securityAuth" module (registered as `twoFactorAuth` in the root store).
 *
 * Manages two-factor authentication (2FA) setup and status: fetching whether
 * 2FA is enabled, generating a QR code/secret for setup, verifying a code to
 * enable 2FA, and disabling 2FA. State (store.js), actions (operations.js),
 * getters (selectors.js), and mutations (updates.js).
 */
import state from "./store";
import mutations from "./updates";
import getters from "./selectors";
import actions from "./operations";

export default {
  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations,
};
